import {isNull} from "@/utils/formatting";

export default {
    props: {
        field: {
            type: Object,
            required: true,
        },
        fieldName: {
            type: String,
            required: true,
        },
        prefixFieldName: {
            type: String,
            default: '',
        },
        value: {
            type: null,
        },
        label: {
            type: String
        },
        errors: {
            type: Object,
        },
        disabled: {
            type: Boolean,
            default: false
        },
        inline: {
            type: Boolean,
            default: true
        },
        placeholder: {
            String,
            default: '',
        },
        bootstrapNative: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            innerErrors: []
        };
    },
    computed: {
        isValid() {
            return this.invalidFeedback === '' ? null : false;
        },
        localError() {
            let foundError = [];
            for(let errorKey in this.errors) {
                if (errorKey === this.fieldName) {
                    foundError = this.errors[errorKey];
                }
            }
            return this.innerErrors.concat(foundError);
        },
        invalidFeedback() {
            if (this.localError.length > 0) {
                return this.localError.join(', ');
            }
            return '';
        },
        fieldId() {
            return (this.prefixFieldName ? this.prefixFieldName + '-' : '') + this.fieldName;
        },
        fieldLabel() {
            return isNull(this.label) ? this.field.label : this.label;
        },
        helpText() {
            if (this.field.hasOwnProperty('help_text')) {
                return this.field.help_text;
            }
            return '';
        },
    },
    methods: {
        changeValue(value) {
            this.$emit('input', value);
        },
    },
};